// Keep shoppers on the product page when adding to basket
(function () {
  async function ajaxAdd(form) {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Add to basket failed');

    // Item successfully added
    await updateCartHeader();
  }

  async function updateCartHeader() {
    try {
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
      const cart = await cartRes.json();

      // Update cart item count
      document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, #CartCount')
        .forEach(el => el.textContent = cart.item_count);

      // Update cart total price (in £)
      const price = (cart.total_price / 100).toFixed(2); // converts pence to pounds
      document.querySelectorAll('.cart-price, .header__cart-price, #CartTotal')
        .forEach(el => el.textContent = `£${price}`);
    } catch(e) {
      console.error("Cart update failed:", e);
    }
  }

  document.addEventListener('submit', function(e){
    const form = e.target;
    const action = form && form.getAttribute('action') || '';
    if (action.includes('/cart/add')) {
      e.preventDefault();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
      ajaxAdd(form).catch(err => {
        console.error(err);
        alert('Sorry—couldn’t add to basket.');
      });
    }
  }, true);

  document.addEventListener('click', function(e){
    const btn = e.target.closest('button[name="add"], input[name="add"]');
    if (!btn) return;
    const form = btn.closest('form');
    const action = form && form.getAttribute('action') || '';
    if (action.includes('/cart/add')) {
      e.preventDefault();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
      ajaxAdd(form).catch(err => {
        console.error(err);
        alert('Sorry—couldn’t add to basket.');
      });
    }
  }, true);
})();
